import { Form, Input, message } from 'antd';
import { ACTION_TITLE } from 'constants/constant';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Component from '../../../../shared/components';
import { I18nFormFields } from '../../../../shared/components/i18n/I18nFormFields';
import { I18nFieldData } from '../../../../shared/types/i18n/i18nTypes';
import { tagService } from '../services/tagService';

const TagAdd: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [i18nName, setI18nName] = useState<I18nFieldData>({});
  const [i18nDescription, setI18nDescription] = useState<I18nFieldData>({});

  return (
    <Component.BasePageComponent>
      <div>
        <div className="people-details-page">
          <h1>Tag</h1>
          <Form form={form} layout="vertical" className="people-details-form">
            <I18nFormFields
              fieldName="name"
              required={true}
              fieldType="input"
              value={i18nName}
              onChange={value => setI18nName(value)}
              placeholder={{
                ko: 'Enter tag name (Korean)',
                en: 'Enter tag name',
                'zh-hans': '请输入标签名称',
                'zh-hant': '請輸入標籤名稱',
                vi: 'Nhập tên thẻ',
              }}
            />
            <Form.Item
              style={{ marginTop: '10px' }}
              name="slug"
              label="Slug"
              rules={[{ required: true, message: 'please enter slug' }]}
            >
              <Input onChange={e => (e.target.value = e.target.value.toLowerCase())} />
            </Form.Item>
            <I18nFormFields
              fieldName="description"
              required={false}
              fieldType="textarea"
              value={i18nDescription}
              onChange={value => setI18nDescription(value)}
              placeholder={{
                ko: 'Enter tag description (Korean)',
                en: 'Enter tag description',
                'zh-hans': '请输入标签描述',
                'zh-hant': '請輸入標籤描述',
                vi: 'Nhập mô tả thẻ',
              }}
            />
          </Form>
        </div>
        <div className="people-detail-update-button">
          <Component.ColorButtonComponent
            text={ACTION_TITLE.ADD}
            onClick={async () => {
              const loadingMessage = message.loading('Creating...', 0);
              try {
                // Validate form first
                await form.validateFields();

                // Get current form values (slug only at this point)
                const formValues = form.getFieldsValue();

                // Prepare complete tag data with i18n fields
                const tagData = {
                  slug: formValues.slug || '',
                  i18n_name: i18nName || {},
                  i18n_description: i18nDescription || {},
                  // Legacy field: use ko value from i18n_name
                  name: i18nName?.ko?.toLowerCase() || '',
                };

                // Pass data directly to tagService
                await tagService.createTag(form, tagData);
                loadingMessage();
                navigate('/tag');
              } catch (error) {
                loadingMessage();
                console.error('Error creating tag:', error);
              }
            }}
          />
        </div>
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(TagAdd);
